<template>
<div class="u-cont">
    <NavBar class="nav-bar" />
    <div class="page-content">
        <Gallery class="gallery" ref="mainGallery" :getWindowContent="getWindowContent" />
        <Uploader />
    </div>
</div>
</template>

<script>
import NavBar from "../components/NavBar";
import Gallery from "../components/Gallery";
import Uploader from "../components/Uploader"

export default {
    name: "FBUpload",
    components: {
        Gallery,
        NavBar,
        Uploader
    },
    data: () => {
        return {
            currentWindow: 0,
            songSelected: false,
            song: ''
        }
    },
    methods: {
        getWindowContent(index = 0) {
            this.currentWindow = index;
        },
        getPressedSong(song) {
            this.songSelected = true;
            this.song = song;
        }
    },
    mounted() {
        this.getWindowContent();
    }
}
</script>

<style scoped>
.main {
    display: flex;
    flex-direction: column;
    /*min-height: 100vh;*/
}

.nav-bar {
    width: 100%;
}

.page-content {
    flex: 1;
}

.music-player {
    width: 100%;
}
</style>
